import { ITaskGroup } from '../../../../types/tasks.types'
import { useState } from 'react'
import Modal from '../../../../shared/Modal'
import TextInput from '../../../../shared/Inputs/TextInput'
import css from '../CreateTextOptionModal/createTextOptionModal.module.css'
import NbmgButton from '../../../../shared/NbmgButton'
import useHttpLoader from '../../../../hooks/useHttpLoader'
import groupsService from '../../../../services/groups.service'

interface IProps {
  group: ITaskGroup
  onClose: () => void
  onUpdated: (g: ITaskGroup) => void
}

const UpdateGroupNameModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [text, setText] = useState(props.group.name)

  const handleSave = () => {
    wait(
      groupsService.updateGroup(props.group.id, { name: text }),
      (resp) => {
        if (resp) {
          props.onUpdated(resp)
        }
      },
      () => {}
    )
  }

  return (
    <Modal onClose={props.onClose}>
      <h2 className="form-header" style={{ textAlign: 'center' }}>
        Редактирование
      </h2>
      <TextInput value={text} name="text" onChange={setText} inscription="Наименование группы" autoFocus={true} />
      <div className={css.footer}>
        <NbmgButton withHands={true} onClick={handleSave as any} loading={loading}>
          Сохранить
        </NbmgButton>
      </div>
    </Modal>
  )
}

export default UpdateGroupNameModal
